import { render, staticRenderFns } from "./RecoverySimulatorQuestionRadio.vue?vue&type=template&id=e6a3166a"
import script from "./RecoverySimulatorQuestionRadio.vue?vue&type=script&lang=js"
export * from "./RecoverySimulatorQuestionRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports